import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  count: {
    marginLeft: theme.spacing(1),
    fontWeight: 700,
    lineHeight: '100%',
    padding: [5, 7],
    color: theme.palette.colors.teal,
    backgroundColor: theme.palette.colors.lightTeal,
    borderRadius: 11,
    overflow: 'hidden',
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/Tabs/components/LabelWithBadge/useStyles.js